import {useCallback, useState} from "react";

export const useDropdown = (initialItemList = []) => {
  const [items, setItems] = useState(initialItemList);
  const [selectedItem, setSelectedItem] = useState(-1);
  const handleDropdownChange = useCallback((item) => {
    setSelectedItem(item);
  }, []);
  const setSelectedItems = useCallback(
    (itemId) => {
      const foundItem = items.find((item) => item.id === itemId);
      if (foundItem) {
        setSelectedItem(foundItem.id);
      }
    },
    [items]
  );
  const renderDropdownValue = useCallback(
    (id) => {
      const result = items.find((item) => item.id === id);
      return result ? `Selected: ${result.text}` : `Select an option`;
    },
    [items]
  );

  return {
    items,
    setItems,
    selectedItem,
    setSelectedItem,
    setSelectedItems,
    handleDropdownChange,
    renderDropdownValue,
  };
};
